<template>
  <b-sidebar
    shadow
    visible
    backdrop
    no-header
    class="show"
    :id="'fulfillments-'+order.order_id"
    body-class="cp-sidebar__body"
    sidebar-class="cp-sidebar"
    @change="toggleScrollbar()"
  >

    <SidebarHeader :title="'Your Shipments'" @clear="toggleScrollbar" />
    <div class="cp-sidebar__main">
      <ProcessingLoader v-if="processing" />
      <template v-else-if="hasShipments">
        <div class="cp-sidebar__trans" v-for="(fulfillment, fulfillmentDate) in fulfillments" v-bind:key="'fulfillment-'+fulfillment.id">
          <div class="cp-sidebar__trans__date">{{fulfillmentDate}}</div>
          <div class="cp-sidebar__trans__info" v-for="(fulfillmentInfo, fulfillmentId) in fulfillment" v-bind:key="'fulfillment-info-'+fulfillmentId">
            <div class="cp-sidebar__trans__info__top">
              <span>#{{fulfillmentId}}</span>
              <span class="badge cp-badge active">{{fulfillmentInfo.status}}</span>
            </div>
            <div class="cp-sidebar__trans__info__item">
              <div class="cp-sidebar__trans__info__item__image fulfillment-image">
                <img :src="getItemImageUrl(fulfillmentInfo.item)" @error="setAltImg(fulfillmentInfo.item)" alt="" />
              </div>
              <div class="cp-sidebar__trans__info__item__info">
                <span class="text-ellipses">{{fulfillmentInfo.item.name}}</span>
                <span v-if="fulfillmentInfo.carrier">Carrier: {{fulfillmentInfo.carrier}}</span>
                <span v-if="fulfillmentInfo.method">Method: {{fulfillmentInfo.method}}</span>
                <span v-if="fulfillmentInfo.tracking">Tracking #: {{fulfillmentInfo.tracking}}</span>
                <span v-if="fulfillmentInfo.rma">RMA #: {{fulfillmentInfo.rma}}</span>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <b-button class="cp-sidebar__btn no-outline-btn mt-0 d-md-none" variant="primary" @click.stop="toggleScrollbar()">
          Done
        </b-button>
      </template>
      <template v-else>
        <div class="centered-block">
          <div class="step-title">No shipment found</div>
        </div>
      </template>
    </div>
  </b-sidebar>
</template>

<script>
import {FulfillmentStatus, FulfillmentStatusStrings} from '@/constants'
import {
  toggleBodyScrollbar,
  getHumanReadableDate,
  getItemImageUrl,
  setFallbackImageUrl, getShortDate
} from '@/utils'
import axios from 'axios'
import ProcessingLoader from '@/components/ProcessingLoader'
import SidebarHeader from '@/components/Sidebar/SidebarHeader'

export default {
  name: 'OrderShipments',
  components: {SidebarHeader, ProcessingLoader},
  props: {
    order: Object
  },
  data: function() {
    return {
      show: false,
      processing: true,
      fulfillments: {}
    }
  },
  computed: {
    hasShipments: function() {
      return this.order && this.order.items.some(item => item.fulfillments && item.fulfillments.length > 0)
    }
  },
  methods: {
    toggleScrollbar: function() {
      toggleBodyScrollbar()
      this.$emit('clear')
    },
    close: function() {
      this.$bvModal.hide('order-fulfillments')
      this.$emit('close')
    },
    populateShipments: function() {
      let fulfillments = {}

      for (let item of this.order.items) {
        for (let fulfillment of item.fulfillments) {
          let date = fulfillment.created
          const rmaNumber = ((fulfillment.status === FulfillmentStatus.RMAPending) ||
            (fulfillment.status === FulfillmentStatus.Returned)) ? fulfillment.rma_number : ''
          const trackingOrRMA = (fulfillment.status === FulfillmentStatus.RMAPending) ? rmaNumber
            : fulfillment.tracking_number

          if (fulfillment.ship_date && fulfillment.ship_date.length) {
            date = fulfillment.ship_date
          }

          if (fulfillment.delivery_date && fulfillment.delivery_date.length) {
            date = fulfillment.delivery_date
          }

          const fulFillmentDate = getHumanReadableDate(date, true)
          if (!fulfillments[fulFillmentDate]) {
            fulfillments[fulFillmentDate] = {}
          }

          fulfillments[fulFillmentDate][fulfillment.id.toString()] = {
            item: item,
            rma: rmaNumber,
            date: getShortDate(date),
            tracking_rma: trackingOrRMA,
            method: fulfillment.ship_method,
            carrier: fulfillment.ship_carrier,
            tracking: fulfillment.tracking_number,
            status: this.getDeliveryStatus(fulfillment)
          }
        }
      }

      this.fulfillments = fulfillments
      this.processing = false
    },
    getItemImageUrl: function(item) {
      return getItemImageUrl(item, 'medium')
    },
    setAltImg: function(event, item) {
      setFallbackImageUrl(event, item, 'medium', true)
    },
    getDeliveryStatus: function(fulfillment) {
      return FulfillmentStatusStrings[fulfillment.status]
    }
  },
  created() {
    toggleBodyScrollbar(true)
    if (this.order) {
      if (Object.values(this.fulfillments).length === 0) {
        if (!this.hasShipments) {
          let requests = []
          if (this.order && this.order.items.length) {
            requests = requests.concat(this.order.items.map((item) => axios.get(`/order_items/${item.id}/fulfillments/`)))
          }

          if (requests.length) {
            this.processing = true
            Promise.all(requests).then(response => {
              this.order['items'] = this.order['items'].map((item, index) => {
                item.fulfillments = response[index].data
                return item
              })
              this.populateShipments()
            }, () => {
              this.processing = false
            })
          } else {
            this.processing = false // not allowed to show shipments, so nothing to do
          }
        } else {
          this.populateShipments(this.order['items'])
        }
        return
      }
    }
    this.processing = false
  }
}
</script>

<style scoped>

</style>
